import React from 'react';
import PropTypes from 'prop-types';

// convert original.png -modulate 100,120 -resize 128x static-map-backdrop.jpg
import backgroundImage from '../images/static-map-backdrop.jpg';

import '../styles/static_backdrop.scss';

const StaticBackdrop = ({ children }) => (
  <div className="static-backdrop-container">
    <div
      className="static-backdrop-backdrop"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    />
    {children}
  </div>
);

StaticBackdrop.defaultProps = {
  children: null,
};

StaticBackdrop.propTypes = {
  children: PropTypes.node,
};

export default StaticBackdrop;
